import script from "./CustomerPrivacyModuleGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerPrivacyModuleGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
